import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

import { globalTourAnchor } from '../../../onboarding/registry/guided-tour.registry';

export interface MobileBottomBarItem {
  id: string;
  label: string;
  icon: string;
  route: string;
  domainId: string;
}

@Component({
  selector: 'app-mobile-bottom-bar',
  standalone: true,
  imports: [RouterLink, LucideAngularModule],
  templateUrl: './mobile-bottom-bar.component.html',
  styleUrl: './mobile-bottom-bar.component.scss'
})
export class MobileBottomBarComponent {
  protected readonly tourAnchor = globalTourAnchor;

  readonly items = input.required<MobileBottomBarItem[]>();
  readonly activeDomainId = input<string | null>(null);
  readonly menuOpen = input(false);
  readonly menuToggle = output<void>();
}
